import axios from "axios"

export const getDocuments = async () => {
  const finalUrl =
      window._HOST + "participant/document"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const uploadDocuments = async (documents) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    },
    withCredentials: true
  }

  const formData = new FormData()
  documents.forEach(doc => {
    formData.append(doc.idDocument, doc.file)
  })
  // formData.append('register_id', 'PMB-0001');

  const response =
    await axios.post(
      window._HOST + 'participant/document',
      formData,
      config
    )

  return response.data
}